import { useRef } from "react";

import ConfirmationPopover from "@/appComponents/Blocks/Composites/ConfirmationPopover/ConfirmationPopover";
import { Flex, Text, Tooltip } from "@theorgchartdev/storybook";
import { appstr } from "@coreapp/utils/appstr";
import { LaunchZendeskHelp } from "@coreapp/utils/LaunchZendeskHelp";

export const CopyBaseChartPopover = ({ handleCopy, dataTestId }) => {
  const openCtrlRef = useRef(null);

  const template = appstr("Confirm copy base chart");
  const replaceDict = {
    customCharts: appstr("custom charts")
  };

  const formatConfig = {
    customCharts: {
      type: "underline",
      onClick: () => LaunchZendeskHelp("27882232468116-Creating-custom-charts")
    }
  };
  const message = appstr("Confirm copy base chart", replaceDict);

  return (
    <Tooltip message={appstr("Create copy")} referenceOpenCtrlRef={openCtrlRef}>
      <ConfirmationPopover
        openCtrlRef={openCtrlRef}
        onSubmit={handleCopy}
        icon={"copy"}
        iconOnly
        iconProps={{ size: "small" }}
        otherHeaderProps={{ title: appstr("Copy base chart") }}
        confirmLabel={appstr("Yes")}
        triggerTestId={dataTestId}
        dataTestPrefix="account-settings-base-charts-copy"
      >
        <Flex gap={"12px"} direction={"column"}>
          <Text dynamic={{ replaceDict, formatConfig, template }}>{message}</Text>
          <Text>{appstr("Are you sure you want to copy base chart")}</Text>
        </Flex>
      </ConfirmationPopover>
    </Tooltip>
  );
};
